import { render, staticRenderFns } from "./organism.modal.ugcUploadImageError.vue?vue&type=template&id=a89a4420"
import script from "./organism.modal.ugcUploadImageError.vue?vue&type=script&lang=ts"
export * from "./organism.modal.ugcUploadImageError.vue?vue&type=script&lang=ts"
import style0 from "./organism.modal.ugcUploadImageError.vue?vue&type=style&index=0&id=a89a4420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports